define('utils/gallery',['jquery'], function ($) {

    var Gallery = function (settings) {
        var $this = this;

        this.item = 1;
        this.total = 0;

        var WindowWidth = $(window).width();
        var SlideCount = $('#slides li').length;
        var SlidesWidth = SlideCount * WindowWidth;

        this.item = 0;
        this.total = SlideCount;

        //$("#slides li:first-child").show();

        $('#left').click(function () {
            $this.slide('back');
        });
        $('#right').click(function () {
            $this.slide('forward');
        });

        $('#slides').on('swipeleft', function () {
            $this.slide('back');
        });

        $('#slides').on('swiperight', function () {
            $this.slide('forward');
        });


        this.slide = function(direction) {

            if (direction == 'back') {
                var $target = this.item - 1;
            }
            if (direction == 'forward') {
                var $target = this.item + 1;
            }

            if ($target == -1) {
                $this.doIt(this.total - 1);
            }
            else if ($target == this.total) {
                $this.doIt(0);
            }
            else {
                $this.doIt($target);
            }


        }

        this.doIt = function(target) {

            var $windowwidth = $(window).width();
            var $margin = $windowwidth * target;
            var $actualtarget = target + 1;

            $("#slides li").hide();
            $("#slides li:nth-child(" + $actualtarget + ")").show();

            this.item = target;

            $('#count').html(this.item + 1);

        }
    };
    return Gallery;
});
